module.exports = __webpack_public_path__ + "static/media/ym_logo.148a7aac.png";